var _excluded = ["breakpoints", "children", "columnsLength", "empty", "emptyContent", "emptyTrProps", "error", "errorContent", "errorTrProps", "loaderLabel", "loaderTrProps", "loading", "look"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { TBody } from "./tbody.js";
import { TrEmpty } from "./tr-empty.js";
import { TrError } from "./tr-error.js";
import { TrLoader } from "./tr-loader.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var StandardTBody = function StandardTBody(_ref) {
  var breakpoints = _ref.breakpoints,
    children = _ref.children,
    columnsLength = _ref.columnsLength,
    empty = _ref.empty,
    emptyContent = _ref.emptyContent,
    emptyTrProps = _ref.emptyTrProps,
    error = _ref.error,
    errorContent = _ref.errorContent,
    errorTrProps = _ref.errorTrProps,
    loaderLabel = _ref.loaderLabel,
    loaderTrProps = _ref.loaderTrProps,
    loading = _ref.loading,
    look = _ref.look,
    tbodyProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(TBody, _extends({}, tbodyProps, {
    breakpoints: breakpoints
  }), emptyContent && empty && !error && !loading && /*#__PURE__*/React.createElement(TrEmpty, _extends({}, emptyTrProps, {
    breakpoints: breakpoints,
    colSpan: columnsLength,
    look: look
  }), emptyContent), error && errorContent && !empty && !loading && /*#__PURE__*/React.createElement(TrError, _extends({}, errorTrProps, {
    breakpoints: breakpoints,
    colSpan: columnsLength,
    look: look
  }), errorContent), !error && !empty && !!loaderLabel && loading && /*#__PURE__*/React.createElement(TrLoader, _extends({}, loaderTrProps, {
    breakpoints: breakpoints,
    colSpan: columnsLength,
    label: loaderLabel,
    look: look
  })), !error && !empty && !loading && children);
};
export { StandardTBody };